import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"basic\"><a href=\"#basic\"></a> Basic </h1><div class=\"py-5\"> Use <code>.indication</code> class on a button and specify the button&#39;s label and progress message and toggle the indicator state with <code>data-kt-indicator=&quot;on&quot;</code> custom HTML attribute: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><button type=\"button\" class=\"btn btn-primary me-10\"><span class=\"indicator-label\"> Submit </span><span class=\"indicator-progress\"> Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button><button type=\"button\" class=\"btn btn-primary\" data-kt-indicator=\"on\"><span class=\"indicator-label\"> Submit </span><span class=\"indicator-progress\"> Please wait... <span class=\"spinner-border spinner-border-sm align-middle ms-2\"></span></span></button></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<!-- Default state -->
        <button type="button" class="btn btn-primary me-10">
          <span class="indicator-label">
            Submit
          </span>
          <span class="indicator-progress">
            Please wait...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>

        <!-- Progress enabled state -->
        <button type="button" class="btn btn-primary" data-kt-indicator="on">
          <span class="indicator-label">
            Submit
          </span>
          <span class="indicator-progress">
            Please wait...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span></button
        >`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}